import { gql } from 'graphql-tag'

const salesIncentiveStatsFragment = gql`
  fragment SalesIncentiveStatsFragment on SalesIncentiveStats {
    staffTarget
    staffActual
    expressCheckoutTarget
    expressCheckoutActual
    chainTarget
    hasExpressCheckout
  }
`

const dailySalesStatsFragment = gql`
  fragment DailySalesStatsFragment on DailySalesStats {
    actual
    target
    actualLastUpdatedAt
  }
`

export const fetchDashboardStats = gql`
  query FetchDashboardStats($stationId: ID!, $date: String!) {
    dashboard(stationId: $stationId, date: $date) {
      dailySales {
        ...DailySalesStatsFragment
      }
      salesIncentive {
        ...SalesIncentiveStatsFragment
      }
      averageFeelingMeter
      feelingsCount
      thumbsUp {
        target
        actual
      }
    }
    reservations: weeksReservations(stationId: $stationId, date: $date) {
      id
      startTime
      endTime
      name
      peopleCount
      otherInfo
      room
      contactName
      contactPhone
      paymentMethod
      reservationType
      mealOptionDescription
    }
    campaigns(date: $date, stationId: $stationId, includeChainCampaigns: true) {
      id
      name
      startTime
      endTime
      description
      offers {
        buy {
          productGroups {
            quantity
            products
          }
        }
        get {
          totalPrice
          productGroups {
            quantity
            discountAmount
            discountPercent
            priceAmount
            products
          }
        }
      }
    }
  }
  ${salesIncentiveStatsFragment}
  ${dailySalesStatsFragment}
`

export const fetchExpressCheckoutMenu = gql`
  query FetchExpressCheckoutMenu($stationId: ID!) {
    restaurantMenuPeriods: expressCheckoutCategoryPeriods(stationId: $stationId) {
      categoryId
      periodName
      startDate
      endDate
    }
    restaurantMenu: expressCheckoutMenu(stationId: $stationId) {
      categories {
        id
        name
      }
    }
  }
`

export const exportReservations = gql`
  mutation ExportReservations($stationId: ID!, $date: String!) {
    exportReservations(stationId: $stationId, date: $date)
  }
`
